import { render, staticRenderFns } from "./BulkFiltersModal.vue?vue&type=template&id=2ff4eb9e&scoped=true"
import script from "./BulkFiltersModal.vue?vue&type=script&lang=ts"
export * from "./BulkFiltersModal.vue?vue&type=script&lang=ts"
import style0 from "./BulkFiltersModal.vue?vue&type=style&index=0&id=2ff4eb9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff4eb9e",
  null
  
)

export default component.exports